// Deployment cache guard.
//
// MUST stay the first import in main.ts: vuex-persistedstate rehydrates
// auth/formData/basket the moment store/index.ts is evaluated, so the purge
// has to run before that import. State persisted by a previous release can be
// incompatible with the current payment flow and strand returning visitors on
// the "Redirecting to payment..." screen, so on the first load of a new build
// we clear persisted state once.
const DEPLOY_VERSION_KEY = 'app_deploy_version'
const buildVersion = process.env.VUE_APP_BUILD_VERSION || 'dev'

try
{
    if(window.localStorage.getItem(DEPLOY_VERSION_KEY) !== buildVersion)
    {
        window.sessionStorage.clear()
        window.localStorage.clear()
        window.localStorage.setItem(DEPLOY_VERSION_KEY, buildVersion)
    }
}
catch
{
    // Storage unavailable (blocked cookies / private browsing) — nothing persisted, nothing to purge.
}

export {}
